import axios from 'axios'
import { getAuthUrl, isAuthenticated } from './auth'
import {
    trackGtmTenantSaveSearch
} from './analytics'

let preferences = window.preferences || []

// Element selectors
const SELECTORS = {
  CREATE_PREFERENCE_BTN: '.create-preference-btn',
  SEARCH_LISTING: '.search-listing',
  LOADING: '.loading',
  SEARCH_RESULTS_TITLE: '.search-results-title',
  SEARCH_RESULT_TEXT: '.search-result-text',
  SEARCH_LIST_ITEMS: '.search-list-items',
  PREFERENCE_LIST_ITEM: '.saved-search-item',
}

/**
 * Disables all create preference buttons
 */
const disableCreatePreference = () =>
  $(SELECTORS.CREATE_PREFERENCE_BTN).addClass('disabled')

/**
 * Enables all create preference buttons
 */
const enableCreatePreference = () =>
  $(SELECTORS.CREATE_PREFERENCE_BTN).removeClass('disabled')

/**
 * Creates a new tenant preference
 * @param searchParams Search parameters/filters as an object
 */
const createPreference = (searchParams) => {
  // Redirect to login if not authenticated
  if (!isAuthenticated()) {
    window.location.href = getAuthUrl()
    return
  }

  // Disable all create preference buttons
  disableCreatePreference()

  // Use bounds from initial page load for location based urls
  // Ex: /ut/salt-lake-city
  if (!searchParams.bounds) {
    searchParams.bounds = eval(
      document.querySelector('#map').getAttribute('data-initial-bounds')
    )
  }

  // Create the preference
  const preferenceCreateInputModel = {
    bounds: searchParams.bounds,
    propertyTypes: searchParams.propertytypes,
    minPrice: searchParams.minprice,
    maxPrice: searchParams.maxprice,
    minBedrooms: searchParams.minbedrooms,
    maxBedrooms: searchParams.maxbedrooms,
    minBathrooms: searchParams.minbathrooms,
    maxBathrooms: searchParams.maxbathrooms,
    minLeaseLength: searchParams.minlease,
    maxLeaseLength: searchParams.maxlease,
    minAcres: searchParams.minacres,
    minYearBuilt: searchParams.minyearbuilt,
    maxYearBuilt: searchParams.maxyearbuilt,
    minSquareFeet: searchParams.minsquarefootage,
    isSmokingAllowed: searchParams.issmokingallowed,
    areSmallDogsAllowed: searchParams.aresmalldogsallowed,
    areLargeDogsAllowed: searchParams.arelargedogsallowed,
    areCatsAllowed: searchParams.arecatsallowed,
    isAcceptingApplications: searchParams.isacceptingapplications,
    keywords: searchParams.keywords,
    amenities: searchParams.amenities,
    title: searchParams.location,
  }

  axios
    .post(`${rentler.apiBaseUri}/preferences`, preferenceCreateInputModel)
    .then(success, error)

  function success() {
    const searchModel = {
      bounds: searchParams.bounds,
      propertyTypes: searchParams.propertytypes,
      minPrice: searchParams.minprice,
      maxPrice: searchParams.maxprice,
      minBedrooms: searchParams.minbedrooms,
      maxBedrooms: searchParams.maxbedrooms,
      minBathrooms: searchParams.minbathrooms,
      maxBathrooms: searchParams.maxbathrooms,
      minLeaseLength: searchParams.minlease,
      maxLeaseLength: searchParams.maxlease,
      minAcres: searchParams.minacres,
      minYearBuilt: searchParams.minyearbuilt,
      maxYearBuilt: searchParams.maxyearbuilt,
      minSquareFeet: searchParams.minsquarefootage,
      isSmokingAllowed: searchParams.issmokingallowed,
      areSmallDogsAllowed: searchParams.aresmalldogsallowed,
      areLargeDogsAllowed: searchParams.arelargedogsallowed,
      areCatsAllowed: searchParams.arecatsallowed,
      isAcceptingApplications: searchParams.isacceptingapplications,
      keywords: searchParams.keywords,
      amenities: searchParams.amenities,
      location: searchParams.location,
    }
    trackGtmTenantSaveSearch({ search: searchModel })
  }

  function error() {
    // On error re-enable all create preference buttons so that
    // users can retry
    enableCreatePreference()
  }
}

const fetchPreferences = () => {
  return axios.get(`${rentler.apiBaseUri}/preferences`).then((response) => {
    $(`${SELECTORS.SEARCH_LISTING} ${SELECTORS.LOADING}`).addClass('show')
    document.querySelector(SELECTORS.SEARCH_LISTING).scrollTop = 0
    renderSavedSearchItems(response.data)
    window.history.replaceState(null, null, response.data.url)
    preferences = response.data.items
    return response.data
  })
}

const renderSavedSearchItems = (data) => {
  $(SELECTORS.SEARCH_LISTING).attr('data-has-results', data.totalCount > 0)
  $(SELECTORS.SEARCH_LISTING).attr('data-saved-searches', 'true')
  $(`${SELECTORS.SEARCH_LISTING} ${SELECTORS.SEARCH_RESULTS_TITLE}`).text(
    data.uiResultsTitle
  )
  $(`${SELECTORS.SEARCH_LISTING} ${SELECTORS.SEARCH_RESULT_TEXT}`).text(
    data.uiResultsSubtitle
  )

  let itemsHtml = ''
  data.items.map((savedSearch) => {
    itemsHtml += `
                <div class="col-12 saved-search-item" data-preference-id="${savedSearch.tenantPreferenceId}">
                    <div class="saved-search-container">
                        <div class="date">${savedSearch.uiCreateDate}</div>
                        <div class="title">${savedSearch.uiTitle}</div>
                        <div class="desc">${savedSearch.uiSubtitle}</div>
                        <div class="btn-action d-flex justify-content-between justify-content-md-start">
                            <button class="delete-btn btn btn-outline btn-delete-preference" class="delete-btn btn btn-outline">Delete</button>
                            <button class="btn btn-primary btn-view-results">View results</button>
                        </div>
                    </div>
                </div>
            `
  })

  $(SELECTORS.SEARCH_LIST_ITEMS).html(itemsHtml)
  $(`${SELECTORS.SEARCH_LISTING} ${SELECTORS.LOADING}`).removeClass('show')
}

const deletePreference = (tenantPreferenceId) => {
  const preferenceItem = $(
    `${SELECTORS.PREFERENCE_LIST_ITEM}[data-preference-id='${tenantPreferenceId}']`
  )
  const preferenceItemDeleteBtn = preferenceItem.find('.delete-btn')

  // Disable the delete button while calling api
  preferenceItemDeleteBtn.addClass('disabled')

  axios
    .delete(`${rentler.apiBaseUri}/preferences/${tenantPreferenceId}`)
    .then(success, error)

  function success() {
    // Remove item from list on success
    preferenceItem.remove()

    const count = $(SELECTORS.PREFERENCE_LIST_ITEM).length
    $(SELECTORS.SEARCH_LISTING).attr('data-has-results', count > 0)
  }

  function error() {
    // On error re-enable delete button so the user can try again
    preferenceItemDeleteBtn.removeClass('disabled')
  }
}

const loadFilterFromPreference = (tenantPreferenceId) => {
  const preference = preferences.find(
    (p) => p.tenantPreferenceId == tenantPreferenceId
  )

  Object.keys(preference.search).map((key) => {
    window.FilterUtility.filterValues[key.toLowerCase()] =
      preference.search[key]
  })

  const propertyTypes = window.FilterUtility.filterValues.propertytypes

  if (propertyTypes && propertyTypes.length) {
    window.FilterUtility.filterValues.propertytypes = propertyTypes.map((p) =>
      p.toLowerCase()
    )
  }

  window.FilterUtility.filterValues.location = ''
  window.MapUtilty.fitBounds(preference.search.bounds)
  window.FilterUtility.searchFilters()
}

export {
  disableCreatePreference,
  enableCreatePreference,
  createPreference,
  fetchPreferences,
  deletePreference,
  loadFilterFromPreference,
}
